import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Secondary tab element
 *
 * @param {{}} props
 * @constructor
 */
const Tab = props => (
    <li className="sales__navItem">
        <a
            className={classNames(
                'ui-link sales__navItemLink',
                { sales__navItemLinkActive: props.active }
            )}
            href={props.link}
            onClick={props.disabled ? (e) => { e.preventDefault(); } : null}
        >
            {props.children}
        </a>
    </li>
);

Tab.propTypes = {
    /**
     * Tab URL
     */
    link: PropTypes.string.isRequired,
    /**
     * Tab label
     */
    children: PropTypes.string,
    /**
     * TRUE to mark tab as active, FALSE otherwise
     */
    active: PropTypes.bool,
    /**
     * Standard anchor property
     */
    disabled: PropTypes.bool,
};

export default Tab;



// WEBPACK FOOTER //
// ./src/js/components/tabs/Tab.js